"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _views = require("../../views");
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  list: {
    path: 'apitester',
    icon: 'brightness_auto',
    title: 'API Tester',
    private: true,
    level: 0,
    //restricted: 'control.apitester',
    component: props => /*#__PURE__*/_react.default.createElement(_views.Template, {
      title: 'API Tester'
    }, /*#__PURE__*/_react.default.createElement(_.ApiTester, null))
  }
};
module.exports = exports.default;